import { RouterModule, Routes } from '@angular/router';
import { ScanManagementComponent } from './scan-management/scan-management.component';
const routes: Routes = [
  {
    path: '',
    component: ScanManagementComponent,
  },
];

export const ScanRoutes = RouterModule.forChild(routes);
